import React from "react";
import { Sparkles } from "lucide-react";

function PageHeader({ title, subtitle, eyebrow = "MekEdge" }) {
  return (
    <section className="relative overflow-hidden border-b border-black/5 bg-[radial-gradient(circle_at_top_left,_rgba(251,191,36,0.18),_transparent_24%),radial-gradient(circle_at_80%_20%,_rgba(14,165,233,0.14),_transparent_18%),linear-gradient(180deg,_#f8f5ef_0%,_#efe7db_100%)] px-6 py-20 text-slate-950 lg:px-10">
      <div className="mx-auto max-w-5xl text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-slate-300/70 bg-white/70 px-4 py-2 text-xs font-semibold uppercase tracking-[0.32em] text-slate-500 backdrop-blur">
          <Sparkles className="h-3.5 w-3.5" />
          {eyebrow}
        </div>
        <h1 className="mt-6 font-serif text-5xl tracking-tight text-slate-950 sm:text-6xl">{title}</h1>
        {subtitle ? (
          <p className="mx-auto mt-5 max-w-3xl text-lg leading-8 text-slate-700">{subtitle}</p>
        ) : null}
      </div>
    </section>
  );
}

export default PageHeader;